
import { useState } from "react";
import { AdminUser, SortField, SortOrder } from "./types";

export const useSortUsers = () => {
  const [sortField, setSortField] = useState<SortField>('created_at');
  const [sortOrder, setSortOrder] = useState<SortOrder>('desc');

  const sortUsers = (unsortedUsers: AdminUser[]) => {
    return [...unsortedUsers].sort((a, b) => {
      let valueA: string | number | Date = '';
      let valueB: string | number | Date = '';

      switch (sortField) {
        case 'created_at':
          valueA = new Date(a.created_at || '');
          valueB = new Date(b.created_at || '');
          break;
        case 'email':
          valueA = a.email || '';
          valueB = b.email || '';
          break;
        case 'role':
          valueA = a.role || '';
          valueB = b.role || '';
          break;
        case 'first_name':
          valueA = `${a.first_name || ''} ${a.last_name || ''}`;
          valueB = `${b.first_name || ''} ${b.last_name || ''}`;
          break;
        default:
          valueA = new Date(a.created_at || '');
          valueB = new Date(b.created_at || '');
      }

      if (sortOrder === 'asc') {
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
      } else {
        if (valueA > valueB) return -1;
        if (valueA < valueB) return 1;
        return 0;
      }
    });
  };

  const handleSort = (field: SortField) => {
    if (field === sortField) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return {
    sortField,
    sortOrder,
    sortUsers,
    handleSort
  };
};
